import { render } from "./MyFrens.vue?vue&type=template&id=131058f8&scoped=true"
import script from "./MyFrens.vue?vue&type=script&lang=js"
export * from "./MyFrens.vue?vue&type=script&lang=js"

import "./MyFrens.vue?vue&type=style&index=0&id=131058f8&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-131058f8"]])

export default __exports__